// Descarga un fichero devuelto por la API (`downloadFile`) con su nombre original.
export async function guardarFichero(fichero: Promise<{ blob: Blob; filename: string }>) {
  const { blob, filename } = await fichero
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
